import React from 'react'
import Spinner from 'react-spinkit'

const LoadingSpinner = () => <Spinner name="circle" />

export const ThreeBounceSpinner = () => <Spinner name="three-bounce" />

export default LoadingSpinner



// WEBPACK FOOTER //
// ./src/components/Global/LoadingSpinner.js